import { useCallback } from 'react'
import { Agent } from '../../index'
import { useIntl } from 'react-intl'
import { downloadAgent } from '../../download-agent'
import { IconProps } from '@contrast-security-inc/design-system-foundations'
import {
  TextProps,
  LinkProps
} from '@contrast-security-inc/design-system-typography'
import { css } from '@emotion/css'

export function useDownloadAgentCallback(
  organizationID: string,
  agent: Agent,
  body?: any
): () => Promise<void> {
  const { formatMessage } = useIntl()
  return useCallback(
    () =>
      downloadAgent({
        organizationID,
        agent,
        formatMessage,
        body
      }),
    [organizationID, agent, body, formatMessage]
  )
}

export const optionsClassName = css`
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
`
export const cardClassName = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 340px;
`
export const linkClassName = css`
  display: flex;
  gap: 8px;
  align-items: center;
`
export const titleProps: TextProps = {
  font: 'bodyStrong',
  color: 'neutral100',
  className: css`
    margin-bottom: 12px;
  `
}
export const subtitleProps: TextProps = {
  font: 'body',
  color: 'neutral100',
  className: css`
    margin-bottom: 16px;
  `
}
export const linkProps: LinkProps = {
  color: 'turquoise90',
  font: 'body',
  isExternal: true,
  className: css`
    margin-bottom: 8px;
    :last-child {
      margin-bottom: 0;
    }
  `
}
export const iconProps: IconProps = {
  size: 'sm',
  color: 'black'
}
